<template>
  <div>
    <!-- Formulario para añadir un nuevo elemento -->
    <v-container class="d-flex align-center">
      <v-textarea @input="processContentNewElement(newElement)" v-model="newElement.description"
        label="Descripción del elemento" @keydown.ctrl.enter="addElement" :rules="[elementLengthRule]"
        class="flex-grow-1 mr-2" persistent-counter counter="500" auto-grow rows="3" outlined dense />

      <!-- Botón al costado derecho -->
      <v-btn color="primary" @click="addElement" :disabled="newElement.description.length > 500">
        Agregar +
      </v-btn>
    </v-container>
    ctrl + enter para enviar.

    <!-- Tipo de elemento -->
    <div v-if="newElement.description" class="mt-2">
      Tipo de elemento:
      <v-chip :color="getLozengeClass(newElement.type)" dark small class="ml-2">
        {{ newElement.type }}
      </v-chip>
    </div>

    <!-- Metadatos para compromiso -->
    <div v-if="newElement.type === 'compromiso'">
      Responsable:
      <v-chip class="ma-1" color="blue lighten-2" outlined>
        {{ newElement.responsable || 'No definido' }}
      </v-chip>

      Fecha límite:
      <v-chip class="ma-1" color="green lighten-2" outlined>
        {{ newElement.dateLimit || 'No definida' }}
      </v-chip>

      Hora límite:
      <v-chip class="ma-1" color="orange lighten-2" outlined>
        {{ newElement.timeLimit || 'No definida' }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import { processContentNewElement } from '@/utils/processText.js'; // Importar la función
import { getLozengeClass } from '@/utils/globalFunctions'; // Importar la función
import api from '@/api.js';
import Element from '@/models/Element.js'; // Importar el modelo de Element

export default {
  name: 'NewElementForm',
  computed: {
    meeting() {
      return this.$store.state.meeting;
    },
    meetingMinute() {
      return this.$store.state.meetingMinute;
    },
    user() {
      return this.$store.state.user;
    },
    isSecretario() {
      return this.meeting.secretario === localStorage.getItem("email");
    },
    project() {
      return this.$store.state.project;
    },
  },
  props: {
    topicNumber: {
      type: Number,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      newElement: new Element(),
      elementLengthRule: (v) => (v?.length <= 500) || "Máximo 500 caracteres permitidos",
    }
  },
  methods: {
    // Método para crear un subproyecto a partir de un compromiso
    createSubprojectFromCommitment() {

    },
    getLozengeClass,
    async addElement() {
      const newElement = this.newElement;
      if (newElement.description.length > 500) {
        this.$store.commit('setSnackbar', { text: 'La descripción excede el límite de 500 caracteres', color: 'error', icon: 'mdi-alert' });
        return;
      }

      try {
        // Compromiso: @Daniel se compromete a terminar la tarea el dia 23-01-2024 a las 13:00
        const newElementData = {
          ...this.newElement,
          meeting: this.$route.params.meetingId,
          project: Array.isArray(this.projectId) ? this.projectId[0] : this.projectId, // Agarra el id del proyecto
          rootProject: this.$route.params.projectId, // Agarra el id de la app  // ojo: recursive-projects
          meetingMinute: this.meetingMinute._id, // ID del acta dialogica
          state: this.project?.kanbanColumns?.[0] ?? 'new', // Estado inicial
          topic: this.topicNumber,
          blocked: false,
          writer: this.user._id
        };

        // Printear el nombre del proyecto asociado al .project del elemento
        // const subproyectos = this.$store.state.subprojects;
        // const proyecto = this.$store.state.project;
        // console.log('nombre nuevo elemento', [...subproyectos, proyecto].find(e => e._id == this.projectId)?.name);
        // console.log('new elementtt', newElementData);

        delete newElementData._id; // Eliminar el ID para evitar conflictos al crear un nuevo elemento

        let type = newElementData.type.toLowerCase();

        if (type == 'compromiso') {
          if (!newElementData.participants?.length > 0) {
            this.$store.commit('setSnackbar', { text: 'Falta el responsable para el compromiso', color: 'error', icon: 'mdi-alert' });
            return;
          }
          if (!newElementData.dateLimit) {
            this.$store.commit('setSnackbar', { text: 'Falta la fecha límite para el compromiso', color: 'error', icon: 'mdi-alert' });
            return;
          }
          if (!newElementData.timeLimit) {
            this.$store.commit('setSnackbar', { text: 'Falta la hora límite para el compromiso', color: 'error', icon: 'mdi-alert' });
            return;
          }
        }

        if (['votación', 'votacion'].includes(type)) {
          if (!this.isSecretario) {
            this.$store.commit('setSnackbar', { text: 'Solo el secretario puede crear una votación', color: 'error', icon: 'mdi-alert' });
            return;
          }
        }


        const response = await api.post(`/api/element`, newElementData);

        if (response.status == 201 || response.status == 200) {
          this.$store.commit('setSnackbar', { text: 'Elemento añadido correctamente', color: 'success', icon: 'mdi-check' });
        }

        this.$socket.emit('event_add_element', {
          room: this.meeting._id,
          user: localStorage.getItem('email'),
          element: response.data
        });

        // Vaciar el input para el tema
        this.newElement = new Element();

        // Añadir el nuevo elemento a la lista local sin recargar
        this.resetForm();
        this.resetNewElement();

      } catch (e) {
        console.error(e);
        this.resetNewElement();
        this.$store.commit('setSnackbar', { text: 'Error al añadir el elemento', color: 'error', icon: 'mdi-alert' });
      }
    },
    resetNewElement() {
      this.newElement = new Element();
    },
    resetForm() {
      // Reseteo del formulario después de añadir el elemento
      this.newElement = new Element();
    },
    getEmailUser(name) {
      let lower_name = name.toLowerCase();

      // Obtener emails de invitados a la reunión
      let emails = [...this.meeting.invitados];

      // Buscar el correo electronico que coincida con el nombre
      let email = emails.find((email) => {
        return email.includes(lower_name);
      });

      return email;
    },
    // Todo: Revisar si se puede borrar este método
    processContentNewElement(newElement) {
      processContentNewElement(newElement, this.getEmailUser.bind(this)); // Usar la función importada
    },
  },
}
</script>

<style lang="scss" scoped></style>